import boards_controllers from "../images/products/boards_controllers.png"

import sensors from "../images/products/sensors.png"
import actuators_motion from "../images/products/actuators_motion.png"
import power_energy from "../images/products/power_energy.png"
import displays_indicators from "../images/products/displays_indicators.png"
import communication_wireless from "../images/products/communication_wireless.png"
import components_prototyping from "../images/products/components_prototyping.png"
import tools_workshop from "../images/products/tools_workshop.png"


export const images = {
    "boards_controllers":boards_controllers,
    "sensors":sensors,
    "actuators_motion":actuators_motion,
    "power_energy":power_energy,
    "displays_indicators":displays_indicators,
    "communication_wireless":communication_wireless,
    "components_prototyping":components_prototyping,
    "tools_workshop":tools_workshop,
}




